export enum PerformerLevels {
  UNASSIGNED = 0,
  PERFORMER = 1,
  POOL = 2
}
